{
  "name": "web-video-player",
  "type": "module",
  "version": "0.0.0",
  "license": "MIT",
  "author": "Beachbody",
  "main": "dist/index.js",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    }
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": "^22"
  },
  "scripts": {
    "start": "tsdown --watch",
    "build": "tsdown",
    "test": "jest --silent",
    "test:watch": "jest --watch --onlyChanged",
    "test:changed": "jest --onlyChanged",
    "test:coverage": "jest --coverage && make-coverage-badge",
    "lint": "eslint src --ext .ts,.tsx && npm run lint:types",
    "lint:types": "tsc --noEmit"
  },
  "dependencies": {
    "@convivainc/conviva-js-coresdk": "4.8.0",
    "@convivainc/conviva-js-html5": "4.0.13",
    "classnames": "2.5.1",
    "easy-peasy": "^6.1.0",
    "lodash": "4.17.21",
    "page-lifecycle": "0.1.2",
    "react": "^19.1.1",
    "react-dom": "^19.1.1",
    "redux-logger": "3.0.6",
    "styled-components": "^6.1.19",
    "ua-parser-js": "1.0.33",
    "uuid": "9.0.1",
    "video.js": "8.23.4",
    "videojs-contrib-quality-levels": "4.1.0",
    "visibilityjs": "2.0.2",
    "yup": "0.29.1"
  },
  "devDependencies": {
    "@babel/core": "7.28.4",
    "@babel/preset-env": "^7.28.3",
    "@babel/preset-react": "^7.27.1",
    "@babel/preset-typescript": "^7.27.1",
    "@rollup/plugin-babel": "^6.0.4",
    "@rollup/plugin-image": "^3.0.3",
    "@testing-library/react": "^16.3.0",
    "@types/chromecast-caf-sender": "1.0.11",
    "@types/classnames": "2.3.4",
    "@types/jest": "25.1.4",
    "@types/lodash": "4.17.20",
    "@types/react": "^19.1.16",
    "@types/react-dom": "^19.1.9",
    "@types/redux-logger": "3.0.13",
    "@types/styled-components": "^5.1.34",
    "@types/ua-parser-js": "0.7.39",
    "@types/uuid": "9.0.7",
    "@types/yup": "0.29.1",
    "@typescript-eslint/eslint-plugin": "^8.45.0",
    "@typescript-eslint/parser": "^8.45.0",
    "babel-jest": "^30.2.0",
    "eslint": "^9.36.0",
    "husky": "7.0.4",
    "jest": "^30.2.0",
    "jest-chrome": "^0.8.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-environment-jsdom-sixteen": "1.0.3",
    "make-coverage-badge": "1.2.0",
    "rollup-plugin-copy": "^3.5.0",
    "rollup-plugin-svg": "2.0.0",
    "tsdown": "^0.15.6",
    "tslib": "2.8.1",
    "typescript": "^5.9.3"
  },
  "sideEffects": false,
  "overrides": {
    "braces": "3.0.3",
    "form-data": "3.0.4",
    "node-notifier": "8.0.1",
    "micromatch": "4.0.8",
    "rollup": "2.79.2",
    "jest-chrome": {
      "jest": "30"
    }
  },
  "prettier": {
    "printWidth": 120,
    "semi": true,
    "singleQuote": true,
    "trailingComma": "es5"
  },
  "husky": {
    "hooks": {
      "pre-push": "npm run lint"
    }
  }
}
